<script setup lang="ts">
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";

/**
 * Bouton d'ajout d'une carte (groupe IA, observation) : contour pointillé à
 * la couleur de la carte (violet par défaut — analyse), pleine largeur, au
 * gabarit d'une ligne d'entité. `active` : l'action est en cours (contour
 * plein, fond teinté). `loading` : un envoi est en cours.
 */

withDefaults(
  defineProps<{
    /** Icône Phosphor. */
    icon: string;
    label: string;
    active?: boolean;
    loading?: boolean;
  }>(),
  { active: false, loading: false },
);

defineEmits<{
  (e: "click"): void;
}>();
</script>

<template>
  <button
    type="button"
    class="card-dashed-btn d-flex align-items-center gap-2"
    :class="{ active }"
    :disabled="loading"
    @click.stop="$emit('click')"
  >
    <span v-if="loading" class="spinner-border spinner-border-sm" />
    <PhosphorIcon
      v-else
      :name="icon"
      :size="18"
      :weight="active ? 'bold' : 'regular'"
    />
    {{ label }}
  </button>
</template>

<style lang="scss" scoped>
.card-dashed-btn {
  width: 100%;
  border: 1px dashed
    color-mix(
      in srgb,
      var(--card-accent-light, var(--dr-report-light)) 45%,
      transparent
    );
  background: transparent;
  color: var(--card-accent-light, var(--dr-report-light));
  border-radius: 6px;
  padding: 5px 6px;
  font-size: 0.84rem;
  cursor: pointer;
  text-align: left;

  &:hover:not(:disabled) {
    background: color-mix(
      in srgb,
      var(--card-accent, var(--dr-report)) 14%,
      transparent
    );
  }

  &.active {
    border-style: solid;
    background: color-mix(
      in srgb,
      var(--card-accent, var(--dr-report)) 30%,
      transparent
    );
    color: white;
  }

  &:disabled {
    cursor: default;
    opacity: 0.7;
  }

  .spinner-border {
    width: 14px;
    height: 14px;
    border-width: 2px;
  }
}
</style>
